import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { SubmitHandler, useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { LoadingButton } from '@mui/lab';
import { SettingConfigurationForm } from './ArcgisCivil3dSettingConfigurationForm';
import { ArcgisCivil3dSettingConfigurationApiModel } from '../../../../../types/models/arcgis-civil3d-setting-configuration.model';
import { useUpdateSettingConfiguration } from '../../../hooks/api/use-arcgis-civil3d-setting-configurations.hook';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  settingConfiguration?: ArcgisCivil3dSettingConfigurationApiModel;
};

const EditArcgisCivil3dSettingConfigurationDetails = ({ isOpen, onClose, settingConfiguration }: Props) => {
  const [updateSettingConfiguration, { loading: updatingSettingConfiguration, error: updateError }] =
    useUpdateSettingConfiguration();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<SettingConfigurationForm>({
    resolver: classValidatorResolver(SettingConfigurationForm),
    values: settingConfiguration,
  });

  const onSubmit: SubmitHandler<SettingConfigurationForm> = async (values) => {
    if (!settingConfiguration) return;

    await updateSettingConfiguration({ ...values, settingConfigurationId: settingConfiguration.id });

    onClose();
  };

  return (
    <Dialog open={isOpen}>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: 600 }}>
        <DialogTitle>Rename ArcGIS Civil 3D Setting Configuration</DialogTitle>
        <DialogContent>
          <TextField
            {...register('name')}
            variant="outlined"
            sx={{ mt: '1rem' }}
            disabled={updatingSettingConfiguration}
            error={Boolean(errors.name)}
            helperText={errors.name?.message}
            label="Name"
            margin="dense"
            size="small"
            fullWidth
          />
          {updateError && (
            <Alert sx={{ mt: '1rem' }} severity="error">
              {updateError?.response?.data?.message}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button disabled={isSubmitting} variant="outlined" onClick={onClose} color="primary">
            Cancel
          </Button>
          <LoadingButton color="primary" type="submit" variant="contained" loading={isSubmitting}>
            Save
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditArcgisCivil3dSettingConfigurationDetails;
